var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Text as ChakraText, useColorModeValue, useTheme, } from "@chakra-ui/react";
import { transparentize } from "../../core";
/**
 * Text is the used to render text and paragraphs within an interface. It renders a `<span>` tag by default.
 */
const Text = forwardRef((_a, ref) => {
    var { colorScheme, variantColor, color, as = "span", size, fontSize, noOfLines } = _a, rest = __rest(_a, ["colorScheme", "variantColor", "color", "as", "size", "fontSize", "noOfLines"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const c = scheme ? `${scheme}.500` : color;
    const textColor = useColorModeValue(c !== null && c !== void 0 ? c : "black", transparentize(c !== null && c !== void 0 ? c : "black", 0.5)(theme));
    return (React.createElement(ChakraText, Object.assign({}, rest, { ref: ref, as: as, color: textColor, fontSize: size || fontSize, noOfLines: noOfLines })));
});
Text.displayName = "Text";
export default Text;
//# sourceMappingURL=Text.js.map